const getters = {
  activeIndex: state => state.nav.activeIndex,
  activeIndexMini: state => state.nav.activeIndexMini,
  slideActive: state => state.nav.slideActive,
  userToken: state => state.user.token,
  userInfo: state => state.user.userInfo,
  isLogin: state => state.user.isLogin,
  nickname: state => state.user.nickname,
  isDyAppOwner: state => state.user.isDyAppOwner,
  isSaasProxyUser: state => state.user.isSaasProxyUser,
  isDeveloper: state => state.user.isDeveloper,
  promotionActiveIndex: state => state.nav.promotionActiveIndex,
  officialAccountActiveIndex: state => state.nav.officialAccountActiveIndex,
  navActiveIndex: state => state.h_nav.activeIndex,
  tabPromotionActiveIndex: state => state.h_nav.promotionActiveIndex,
  tabOfficialActiveIndex: state => state.h_nav.officialActiveIndex,
  personalActiveIndex: state => state.nav.personalActiveIndex,
  officialItemActiveIndex: state => state.nav.officialItemActiveIndex,
  packageRecordId: state => state.official.packageRecordId,
  isShowSlide: state => state.official.isShowSlide,
  isGoOfficial: state => state.nav.isGoOfficial,
  kfcAccountActiveIndex: state => state.nav.kfcAccountActiveIndex,
  platformNameKfc: state => state.kfc.platformNameKfc,
  headImgKfc: state => state.kfc.headImgKfc,
  movieShowDialog: state => state.nav.movieShowDialog,
  appKey: state => state.user.appKey,
  showAppKey: state => state.user.showAppKey,
  addKfcDialog: state => state.open.addKfcDialog,
  selectItem: state => state.nav.selectItem,
  isOpenDouyin: state => state.nav.isOpenDouyin,
  curentPhoneNumber: state => state.user.curentPhoneNumber,
  isOpenKuaiShou: state => state.nav.isOpenKuaiShou,
  isHoliday: state => state.user.isHoliday,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js